import {LinearProgress} from '@mui/material';
import React from "react";

export const Progress: React.FC = () => {
    return (
        <div className="defaultCenter">
            <LinearProgress/>
        </div>
    )
}